import { render, staticRenderFns } from "./giftSticker.vue?vue&type=template&id=38a072c1&"
import script from "./giftSticker.vue?vue&type=script&lang=js&"
export * from "./giftSticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports